import { ValidatorService } from './../../../services/tools/validator.service';
import { AutenticacionService } from './../../../services/autenticacion.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var $;

@Component({
  selector: 'app-recuperar-password',
  templateUrl: './recuperar-password.component.html',
  styleUrls: ['./recuperar-password.component.scss']
})
export class RecuperarPasswordComponent implements OnInit {

  public emailToRecover:any;
  public processing:boolean;
  public callback: string;
  @Output() recoveryCallback: EventEmitter<string> = new EventEmitter;
  constructor(private authService: AutenticacionService, private validatorService: ValidatorService) {
    this.processing = false;
  }

  ngOnInit() {
  }

  open() {
    this.emailToRecover = ''
    $('#recuperarPasswordModal').modal('show');
  }

  close() {
    $('#recuperarPasswordModal').modal('hide');
  }

  reset() {
    this.processing = false;
    this.emailToRecover = '';
    this.close();
  }

  isEmail() {
    if (typeof this.emailToRecover != 'string') {
      return false;
    }
    
    return this.validatorService.email(this.emailToRecover);
  }

  recuperar() {

    if(!this.isEmail()) {
      return false;
    }

    this.processing = true;
    this.authService.recuperarPassword(this.emailToRecover).subscribe(
      (response) => {
        this.processing = false;
        const content_response = response.json().content;
        const user = content_response.user;
        this.recoveryCallback.emit('Se ha enviado un correo electrónico al usuario ' + user.email + '.');
        this.reset();
      }, (error) => {
        this.processing = false;
        const content_error = error.json().content;
        let message = 'No se completó la acción. Por favor, intentelo más tarde.';
        if (error.status == 400 && (content_error.error == 'invalid_credentials' || content_error.username)) {
          message = 'El usuario ingresado no coincide con nuestra base de datos, inténtelo nuevamente.';
        }

        this.recoveryCallback.emit(message);
        this.reset();
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/autenticacion/recuperar-password/recuperar-password.component.ts